import { render, staticRenderFns } from "./pelengkap.vue?vue&type=template&id=0e010d75"
import script from "./pelengkap.vue?vue&type=script&lang=js"
export * from "./pelengkap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports